import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined

export const isSupabaseConfigured = Boolean(url && publishableKey && !url.includes('your-project'))

export const supabase = createClient(
  url || 'https://placeholder.supabase.co',
  publishableKey || 'placeholder-publishable-key',
  {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    realtime: { params: { eventsPerSecond: 4 } },
  },
)

export const publicAssetUrl = (path: string | null) => {
  if (!path || !isSupabaseConfigured) return null
  return supabase.storage.from('public-assets').getPublicUrl(path).data.publicUrl
}
